var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookMarkNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99731 19.5026V6.99734C4.99731 5.3398 6.34102 3.99609 7.99856 3.99609H16.0019C17.6594 3.99609 19.0031 5.3398 19.0031 6.99734V19.5026C19.0033 19.6901 18.8985 19.8619 18.7318 19.9477C18.565 20.0335 18.3643 20.0189 18.2118 19.9097L12.2914 15.68C12.1173 15.5554 11.8832 15.5554 11.7091 15.68L5.78864 19.9087C5.63629 20.0178 5.43579 20.0325 5.26911 19.947C5.10243 19.8614 4.99754 19.6899 4.99731 19.5026Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookMarkNew);
export default __webpack_public_path__ + "static/media/book-mark-new.d5a8cda2f974f3bb3631d75034ae1fe2.svg";
export { ForwardRef as ReactComponent };